import './styles/frontPageLayout.css';
import {Link} from "react-router-dom";

export default function App() {
    return (<>
        <link rel="icon" href="/home.ico"/>
        <div className="frontpage">
            <div className="header">
                Welcome to the personal web pages of Simon and Wendy
            </div>

            <table className="full-height">
                <tbody>
                <tr>
                    <td className="box" align="center">
                        <Link to="sk" title="Click on to go to Simon's pages on stuff">
                            <img alt="Click on to go to Simon's pages on stuff"
                                 border="0"
                                 src="/images/gears.gif"
                                 width="60"
                                 height="60"/>
                            <br/>
                            Simon's personal vanity page on stuff
                        </Link>
                    </td>
                    <td/>
                </tr>
                <tr>
                    <td/>
                    <td className="box" align="center">
                        <a href="http://www.singinglessonsglasgow.co.uk/" title="Click on to go to Wendy's pages on Teaching Singing and voice coaching">
                            <img alt="Click on to go to Wendy's pages on Teaching Singing and voice coaching"
                                 border="0"
                                 src="/images/clef.gif"
                                 width="100"
                                 height="130"/>
                            <br/>
                            Wendy's pages on Teaching Singing and voice coaching
                        </a>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </>);
}
